import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useRef } from "react";
import OverviewBox from "../components/OverviewBox";
import AsignacionesTable from "../components/AsginacionesTable";
import { useGlobalContext } from "../Config";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { Toast } from "primereact/toast";
import AlertasDialog from "../components/AlertasDialog.js";
import { useLocation } from "react-router-dom";

const Asignacion = (props) => {
  const motivosRenovacion = [{ label: "Buen cumplimiento", value: "Buen cumplimiento" },{ label: "Continuidad de uso", value: "Continuidad de uso" },{ label: "Conveniencia mutua", value: "conveniencia mutua" },{ label: "Mismo acuerdo previo", value: "Mismo acuerdo previo" },{ label: "Ajuste por IPC", value: "Ajuste por IPC" },{ label: "Buena relación", value: "Buena relación" },{ label: "Sin cambio de uso", value: "Sin cambio de uso" },{ label: "Por solicitud del arrendatario", value: "Por solicitud del arrendatario" },{ label: "Mantener arrendatario", value: "Mantener arrendatario" },{ label: "Extensión temporal", value: "Extensión temporal" }];
  const motivosNoRenovacion = [{ label: "ESPECIFICACIÓN TECNICA", value: "ESPECIFICACION TECNICA" },{ label: "FIDELIZACIÓN COMERCIAL", value: "FIDELIZACION COMERCIAL" },{ label: "FIDELIZACIÓN LOGISTICA", value: "FIDELIZACION LOGISTICA" },{ label: "LINEA DE CREDITO", value: "LINEA DE CREDITO" },{ label: "PLAZO DE ENTREGA", value: "PLAZO DE ENTREGA" },{ label: "PLAZO DE PAGO", value: "PLAZO DE PAGO" },{ label: "PRECIO(S)", value: "PRECIO(S)" },{ label: "SERVICIOS", value: "SERVICIOS" },{ label: "STOCK DISPONIBLE", value: "STOCK DISPONIBLE" },{ label: "OBRA DETENIDA", value: "OBRA DETENIDA" }];

  const [asignaciones, setAsignaciones] = useState([]);
  const [asignacionesVigentes, setAsignacionesVigentes] = useState([]);
  const [asignacionesPasadas, setAsignacionesPasadas] = useState([]);
  const [asignacionesFuturas, setAsignacionesFuturas] = useState([]);
  const [tableData, setTableData] = useState(asignaciones);
  const [activeTab, setActiveTab] = useState("Vigentes");
  const [filters2] = useState(null);
  const [loading2, setLoading2] = useState(true);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [fila, setFila] = useState(null);
  const [producto, setProducto] = useState(null);
  const { baseUrl } = useGlobalContext();
  const estados = ["A", "E"];
  const usuarioId = sessionStorage.getItem("usuario_id");
  const [loading, setLoading] = useState(false);
  //mensajes de redireccionamiento toast
  const toast = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const hasShownToastRef = useRef(false);
  const [isAlertDialogVisible, setIsAlertDialogVisible] = useState(false);
  const [alertDialogContent, setAlertDialogContent] = useState("");
  const [postAlertNavigateUrl, setPostAlertNavigateUrl] = useState(null);
  const [renewProps, setRenewProps] = useState(null);

  useEffect(() => {
    const incomingToast = location.state?.toast;
    if (incomingToast && !hasShownToastRef.current) {
      hasShownToastRef.current = true;
      if (Array.isArray(incomingToast)) {
        incomingToast.forEach((t) => toast.current?.show(t));
      } else {
        toast.current?.show(incomingToast);
      }
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, toast: undefined },
      });
    }
  }, [location.state, navigate, location.pathname]);


  const formatDate = (value) => {
    return value.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  const buildAsignacionesUrl = (usuarioId) => {
    return `${baseUrl}getCotizacionesByEstados?idUsuario=${usuarioId}&estados=${[
      "5",
    ]}`;
  };
  const fetchData = async (url) => {
    const requestOptions = {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Network response was not ok. Status: ${response.status}`
      );
    }

    return response.json();
  };


  useEffect(() => {
    const getAsignaciones = async () => {
      try {
        setLoading2(true);
  
        const url = buildAsignacionesUrl(usuarioId);
        const data = await fetchData(url);
  
        if (Array.isArray(data.cotizaciones)) {
          const today = moment().tz("America/Santiago");
  
          const categorized = data.cotizaciones.reduce(
            (acc, asignacion) => {
              const desde = moment.tz(asignacion.desde, "DD/MM/YYYY", "America/Santiago");
              const hasta = moment.tz(asignacion.hasta, "DD/MM/YYYY", "America/Santiago");
  
              if (hasta.isBefore(today, "day")) {
                acc.pasadas.push(asignacion);
              } else if (today.isBetween(desde, hasta, "day", "[]")) {
                acc.vigentes.push(asignacion);
              } else {
                acc.futuras.push(asignacion);
              }
  
              return acc;
            },
            { pasadas: [], vigentes: [], futuras: [] } 
          );
  
          // Update all states at once
          setAsignaciones(data.cotizaciones);
          setTableData(categorized.vigentes);
          setAsignacionesPasadas(categorized.pasadas);
          setAsignacionesVigentes(categorized.vigentes);
          setAsignacionesFuturas(categorized.futuras);
        } else {
          console.error("Data.cotizaciones no es array:", data.cotizaciones);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading2(false);
      }
    };
  
    getAsignaciones();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  const desdeBodyTemplate = (rowData) => {
    return formatDate(rowData.desde);
  };

  const hastaBodyTemplate = (rowData) => {
    return formatDate(rowData.hasta);
  };

  const estadoBodyTemplate = (rowData) => {
    return (
      <span className={`customer-badge status-${rowData.estado}`}>
        {rowData.estado}
      </span>
    );
  };

  const estadoFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={estados}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        itemTemplate={statusItemTemplate}
        placeholder="Select a Status"
        className="p-column-filter"
        showClear
      />
    );
  };

  const statusItemTemplate = (option) => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button
          icon="pi pi-eye"
          label="Ver detalles"
          className="p-button-rounded p-button-info p-button mr-2 mb-2 mt-2"
          outlined
          onClick={() => handleRowClick(rowData)}
        />
      </div>
    );
  };

  const [menu1, menu2, menu3] = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const overviewChartData1 = {
    labels: [
      "Diciembre",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
    ],
    datasets: [
      {
        data: [50, 64, 32, 24, 18, 27, 20, 36, 30],
        borderColor: ["#4DD0E1"],
        backgroundColor: ["rgba(77, 208, 225, 0.8)"],
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const overviewChartData3 = {
    labels: [
      "Diciembre",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
    ],
    datasets: [
      {
        data: [20, 29, 39, 36, 45, 24, 28, 20, 15],
        borderColor: ["#4DD0E1"],
        backgroundColor: ["rgba(77, 208, 225, 0.8)"],
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const overviewChartData4 = {
    labels: [
      "Diciembre",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
    ],
    datasets: [
      {
        data: [30, 39, 50, 21, 33, 18, 10, 24, 20],
        borderColor: ["#4DD0E1"],
        backgroundColor: ["rgba(77, 208, 225, 0.8)"],
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };
  const overviewChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        display: false,
      },
      x: {
        display: false,
      },
    },
    tooltips: {
      enabled: false,
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  const chart1 = useRef(null);
  const buildDetalleCotizacionUrl = (idCotizacion) => {
    return `${baseUrl}getDetalleCotizacionByIdCotizacion?idCotizacion=${idCotizacion}`;
  };
  const handleRowClick = async (rowData) => {
    const idCotizacion = rowData.id;

    // Function to format date, ensuring the output is always in 'yyyy-mm-dd'
    const formatDate = (date, inputFormat) => {
      const parsedDate = moment(date, inputFormat);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
    };

    const formattedDesde = formatDate(rowData.desde, "DD/MM/YYYY");
    const formattedHasta = formatDate(rowData.hasta, "DD/MM/YYYY");

    if (rowData.estado.estado === "INGRESADA") {
      let newUrl = `/selectProductos?idCotizacion=${idCotizacion}&idCliente=${rowData.cliente.id}&selected=true&activeIndex=1`;
      navigate(newUrl);
    } else {
      try {
        setLoading(true);
        const detalleCotizacionUrl = buildDetalleCotizacionUrl(idCotizacion);

        const data = await fetchData(detalleCotizacionUrl);

        if (data.mensaje === "OK") {
          const encodedParams = data.detalles
            .map((item) => {
              // Omit 'desde' and 'hasta' properties
              const { ...rest } = item;
              // Convert the object to a URL parameter string
              return encodeURIComponent(JSON.stringify(rest));
            })
            .join(",");

          let newUrl = `/revisarCotizacion?idCliente=${rowData.cliente.id}&idCotizacion=${idCotizacion}&desde=${formattedDesde}&hasta=${formattedHasta}`;
          const alertas = Array.isArray(rowData.alertas) ? rowData.alertas : [];
          if (alertas.length > 0) {
            const items = alertas.map(a => a.mensajeHtml).filter(m => typeof m === 'string' && m.trim() !== '');
            const html = items.length
              ? `<ul style="padding-left:1.25rem;margin:0;">${items.map(m => `<li>${m}</li>`).join('')}</ul>`
              : 'Sin alertas';
            setAlertDialogContent(html || 'Sin alertas');
            setPostAlertNavigateUrl(newUrl);
            setRenewProps({ idCotizacion, idCliente: rowData.cliente.id, RazonSocial: rowData.cliente.razonSocial, desde: formattedDesde, hasta: formattedHasta });
            setIsAlertDialogVisible(true);
          } else {
            navigate(newUrl);
          }
        } else {
          alert(data.mensaje);
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message);
        } else {
          alert("Hubo un error al crear la cotización");
        }
      } finally {
        setLoading(false);
      }
    }
  };
  function getItemsAboutToEnd(data) {
    const today = moment();

    const aboutToEndItems = data?.filter((item) => {
      const hastaDate = moment(item.hasta, "DD/MM/YYYY");
      const avisoDays = item.aviso;

      const startWindow = hastaDate.clone().subtract(30 + avisoDays, "days");

      const isInTimeWindow = today.isBetween(
        startWindow,
        hastaDate,
        "day",
        "[]"
      );

      return isInTimeWindow;
    });

    return aboutToEndItems;
  }

  const itemsAboutToEnd = getItemsAboutToEnd(asignaciones);
  const handleAsignacionesClick = () => {
    setTableData(asignaciones);
    setActiveTab("Todas");
  };

  const handleItemsAboutToEndClick = () => {
    setTableData(itemsAboutToEnd);
    setActiveTab("Proximos Vencimientos");
  };
  const filterAsignaciones = (category) => {
    switch (category) {
      case "históricas":
        setTableData(asignacionesPasadas);
        setActiveTab("Históricas");
        break;
      case "vigentes":
        setTableData(asignacionesVigentes);
        setActiveTab("Vigentes");
        break;
      case "futuras":
        setTableData(asignacionesFuturas);
        setActiveTab("Futuras");
        break;
      default:
        setTableData(asignaciones);
        setActiveTab("Todas");
    }
  };
  return (
    
    <div className="grid table-demo">
      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Asignaciones</h4>
          <h6 style={{ marginTop: "5px" }}>¿Qué contratos tenemos?</h6>
        
          <Toast ref={toast} />

          <div className="grid">
            <OverviewBox
              icon="pi-shopping-cart"
              title="Todas las Asignaciones"
              menuRef={menu1}
              chartRef={chart1}
              chartData={overviewChartData1}
              chartOptions={overviewChartOptions}
              amount={asignaciones?.length}
              status=""
              onClick={handleAsignacionesClick} // Set table data to asignaciones
            />

            <OverviewBox
              icon="pi pi-stopwatch"
              title="Proximos Vencimientos"
              menuRef={menu3}
              chartRef={null}
              chartData={overviewChartData4}
              chartOptions={overviewChartOptions}
              amount={itemsAboutToEnd?.length}
              onClick={handleItemsAboutToEndClick} // Set table data to itemsAboutToEnd
            />

            <OverviewBox
              icon="pi-history"
              title="Históricas"
              menuRef={menu2}
              chartRef={null}
              chartData={overviewChartData3}
              chartOptions={overviewChartOptions}
              amount={asignacionesPasadas?.length}
              onClick={() => filterAsignaciones("históricas")}
            />

            <OverviewBox
              icon="pi-forward"
              title="Futuras"
              menuRef={menu2}
              chartRef={null}
              chartData={overviewChartData3}
              chartOptions={overviewChartOptions}
              amount={asignacionesFuturas?.length}
              onClick={() => filterAsignaciones("futuras")}
            />
          </div>
          
          <div className="field" style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px" }}>
            <Button
              label="Históricas"
              icon="pi pi-backward"
              className="ml-2 mr-2 mb-2 mt-2 p-button-rounded p-button"
              style={{ backgroundColor: "#800020" }}
              onClick={() => filterAsignaciones("históricas")}
              raised
            />
            <Button
              label="Vigentes"
              icon="pi pi-pause"
              className="mr-2 mb-2 mt-2 p-button-rounded p-button"
              style={{ backgroundColor: "#008000" }}
              type="button"
              onClick={() => filterAsignaciones("vigentes")}
              raised
            />
            <Button
              label="Futuras"
              icon="pi pi-forward"
              className="mr-2 mb-2 mt-2 p-button-rounded p-button"
              style={{ backgroundColor: "#00CED1" }}
              type="button"
              onClick={() => filterAsignaciones("futuras")}
              raised
            />
          </div>
        </div>
      </div>
      <AsignacionesTable
        activeTab={activeTab}
        asignaciones={tableData}
        filters={filters2}
        loading={loading2}
        desdeBodyTemplate={desdeBodyTemplate}
        dateFilterTemplate={dateFilterTemplate}
        hastaBodyTemplate={hastaBodyTemplate}
        estadoBodyTemplate={estadoBodyTemplate}
        estadoFilterTemplate={estadoFilterTemplate}
        actionBodyTemplate={actionBodyTemplate}
        setDisplayBasic={setDisplayBasic}
        displayBasic={displayBasic}
        fila={fila}
        setFila={setFila}
        producto={producto}
        setProducto={setProducto}
        handleRowClick={handleRowClick}
      />

      <AlertasDialog
        visible={isAlertDialogVisible}
        htmlContent={alertDialogContent}
        onContinue={() => {
          const url = postAlertNavigateUrl;
          setIsAlertDialogVisible(false);
          setPostAlertNavigateUrl(null);
          setRenewProps(null);
          if (url) navigate(url);
        }}
        onCancel={() => { setIsAlertDialogVisible(false); setPostAlertNavigateUrl(null); setRenewProps(null); }}
        renewProps={renewProps}
        motivosOptions={motivosRenovacion}
        motivosOptions2={motivosNoRenovacion}
        onToast={(msg) => toast.current?.show(msg)}
      />
    </div>
  );
};

export default Asignacion;
